<template>
  <div class="home_index" ref="home_index">
    <div class="index_box">
      <form action="/">
        <div>
          <van-search 
          v-model="keyword"
          shape="round"
          background="#f1f3ff"
          @search="onSearch"
          placeholder="请输入搜索关键词" />
        </div>
      </form>
      <div>
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item v-model="area" :options="arealist" @change="areaChange" />
          <van-dropdown-item v-model="type" :options="typelist" @change="typeChange" />
          <van-dropdown-item v-model="month" :options="timelist" @change="timeChange" />
        </van-dropdown-menu>
      </div>
      <div class="examlist_box">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getCalendarList"
          :immediate-check="false"
        >
          <div class="list_box" v-for="(item) in list" :key="item.id" @click="gotodetail(item.id)">
            <img class="list_img" :src=item.image>
            <div class="list_c_b">
              <p>{{item.title}}</p>
              <p>报名：{{item.startTime.substring(0,16)=='1970-01-01 08:00'? '不详' : item.startTime.substring(0,10)}}~{{item.endTime.substring(0,16)=='1970-01-01 08:00'? '不详' : item.endTime.substring(0,10)}}</p>
              <p>考试：{{item.doTime.substring(0,16)=='1970-01-01 08:00'? '不详' : item.doTime.substring(0,10)}}</p>
              <p>查询：{{item.checkTime.substring(0,16)=='1970-01-01 08:00'? '不详' : item.checkTime.substring(0,10)}}</p>
            </div>
            <van-icon name="arrow" class="list_c_r" size="16" color="#ababab" />
          
          </div>
        </van-list>
      </div>
    </div>
    <tab-bar :current-index="0" />
  </div>
</template>
<script type="text/ecmascript-6">
import {
  Image as VanImage,
  Grid as VanGrid,
  GridItem as VanGridItem,
  Search as VanSearch,
  List as VanList,
  Icon as vanIcon,
  DropdownMenu as VanDropdownMenu,
  DropdownItem as VanDropdownItem,
  Toast
} from 'vant';
import Vue from "vue";
import API from "../api";
import axios from "axios";
import TabBar from '../components/tabbar.vue';
export default {
  name: "",
  components: {
   TabBar,
   VanImage,
   VanGrid,
   VanGridItem,
   VanSearch,
   VanList,
   vanIcon,
   VanDropdownMenu,
   VanDropdownItem,
  },
  data() {
    return {
      username: "",
      list: [],
      typelist:[],
      arealist:[],
      timelist:[],
      loading: false,
      finished: false,
      listData:{},
      month:"all",
      type:"0",
      area:"1",
      keyword:'',
      page:1,
      size:15,
    };
  },
  computed: {
     
  },
  mounted() {
    var date=new Date;
    var year=date.getFullYear(); 
    var month=date.getMonth()+1;
    month =(month<10 ? "0"+month:month); 
    // this.month = (year.toString()+'-'+month.toString());
    var last_year_month = function(){
      var result = [];
          for(var i = 0; i < 12; i++) {
              var d = new Date();
              d.setDate(1);
             d.setMonth(d.getMonth() + i);
             var m = d.getMonth() + 1;
 
            m = m < 10 ? "0" + m : m;
            //在这里可以自定义输出的日期格式
             result.push({value:d.getFullYear() + "-" + m,text:d.getFullYear() + "-" + m});
             //result.push(d.getFullYear() + "年" + m + '月');
        }
        return result;
    };
    for(var allinfo = last_year_month(), i = 0; i < allinfo.length; i++) {
        this.timelist[i]=allinfo[i];
     }

    this.timelist.unshift({value: 'all', text: '当年月份'})
    // console.log(this.timelist)
    this.getCalendarList();
    this.getSubType();
    this.getAreaList();
  },
  
  methods: {
    async getBanner(){
      const res = await API.getIndexBanner();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.bannerData = res.data.data.list;
        //console.log(this.bannerData)
      } else {
        Toast(res.data.message);
      }
    },
    async getSubType(){
      //console.log(this.typeId)
      const res = await API.getSubType();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        // this.typeData = res.data.data;
        // this.examid=this.typeData[0].id
        this.typelist=res.data.data;
        // console.log(res.data.data)
        // this.getExamList();
      } else {
        Toast(res.data.message);
      }
    },
    async getAreaList(){
      //console.log(this.typeId)
      const res = await API.getAreaList();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        // this.typeData = res.data.data;
        // this.examid=this.typeData[0].id
        this.arealist=res.data.data;
        // console.log(res.data.data)
        // this.getExamList();
      } else {
        Toast(res.data.message);
      }
    },
    async getCalendarList() {
        // console.log(this.month,this.type,this.area,this.keyword,this.page,this.size)
        const res = await API.getCalendarList({month:this.month,type:this.type,area:this.area,keyword:this.keyword,page:this.page,size:this.size});
        this.loading = false;
        if(res.data.code === 444){
          //console.log(res.data.data)
          window.location.href = res.data.data
        }else if (res.data.code === 200) {
          // console.log(res.data.data)
          this.list.push(...res.data.data.list)
          // console.log(this.list.length,res.data.data.count,this.loading,this.page)
          if (this.list.length < res.data.data.count) {
          //console.log(2)
            this.page += 1;
          }else{
            this.finished = true;
          }
        } else {
          this.finished = true;
          Toast(res.data.message);
        }
      
    },
    refresh(){
      this.page=1;
      this.list=[];
      this.loading = true;
      this.finished = false;
      this.getCalendarList();
    },
    onSearch(val){
      this.keyword=val;
      this.refresh();
    },
    areaChange(value){
        // console.log(value)
        this.area = value;
        this.refresh();
    },
    typeChange(value){
        // console.log(value)
        this.type = value;
        this.refresh();
    },
    timeChange(value){
        // console.log(value)
        this.month = value;
        this.refresh();
    },
    // changetype(id){
    //   console.log(id);
    //   this.examid=id;
    //   //console.log(this.examid);
    //   this.page=1;
    //   this.list=[];
    //   this.loading = true;
    //   this.finished = false;
    //   this.getExamList();
    // },
    gotodetail(id){
      //console.log(id);
      this.$router.push({ name: 'examdetail', params: { id: id } });
    }
  }
};
</script>



// WEBPACK FOOTER //
// examlist.vue?2c368295